import { merge } from '../../../../../shared/utils/commonUtils'
/* global FB */
/* eslint no-undef: "error" */
const facebookBindAccount = ({ fbServices }) => serviceConfig => {
  const bindAccountService = fbat => {
    fbServices.facebookBindAccount(merge(serviceConfig, { params: { fbat } }))
  }

  FB.getLoginStatus(({ status, authResponse: { accessToken } = {} }) => {
    if (status === 'connected') {
      bindAccountService(accessToken)
    } else {
      FB.login(({ authResponse: { loginAccessToken } = {} }) => {
        if (loginAccessToken) {
          bindAccountService(loginAccessToken)
        }
      }, { scope: 'email' })
    }
  })
}

export default facebookBindAccount
